import * as React from "react";
import {useState} from "react";
import {useMain} from "../../../../Utils/SessionControls/mainContext";
import OdxModal from '../../../../OdxComponents/NativeOdx/Modal/Odx-Modal';
import {deleteApiKeys, getApiKeys} from "../../BackendFacade/apiCalls";
import {IApiKey} from "../../Interfaces/IApiKeyManagement";
import {GlobalDictionary} from "../../../../Utils/globalDictionary";
import {simplifyForHtmlId} from "../../../../Utils/transformer";

interface IProps {
    onSuccessFunction: () => void;
    closeFunction: () => void;
    apiKey: IApiKey;
    currentProject: string;
}

const deleteApikey: React.FC<IProps> = ({closeFunction, onSuccessFunction, apiKey, currentProject}) => {
    const {setLoading, createToast, createErrorToast} = useMain();
    const baseId = `hub-delete-api-key-${simplifyForHtmlId(apiKey.apiKeyId || apiKey.displayName)}`;
    const [apiKeys, setApiKeys] = useState<IApiKey[]>([]);

    const applyDelete = () => {
        setLoading(true);
        deleteApiKeys(apiKey.projectId, apiKey.apiKeyId).then(async (data) => {
            if (!data.success) {
                setLoading(false);
                createErrorToast(data.message);
            } else {
                await getApiKeysWait();
                onSuccessFunction();
                closeFunction();
                createToast({message: "API Key deleted successfully", variant: "success", title: "Success"});
            }
        });
    };

    const getApiKeysWait = async () => {
        setLoading(true);
        await getBackendApiKeys();
    };

    const getBackendApiKeys = async () => {
        getApiKeys(currentProject).then((data) => {
            if (data.success) {
                GlobalDictionary.set("apiKeys" + currentProject, data.data.value);
                setApiKeys(data.data.value as IApiKey[]);
            } else {
                createErrorToast("Error getting API Keys: " + data.message);
            }
            setLoading(false);
        });
    };

    return (
        <OdxModal
            size={"medium"}
            title={`Delete ${apiKey.displayName}`}
            onClose={closeFunction}
            footerButtons={[
                <odx-button
                    key="cancel"
                    id={`OdxButton_${baseId}-cancel-btn`}
                    variant="ghost"
                    size="lg"
                    type="button"
                    onClick={closeFunction}
                >
                    Cancel
                </odx-button>,
                <odx-button
                    key="delete"
                    id={`OdxButton_${baseId}-confirm-btn`}
                    variant="danger"
                    size="lg"
                    type="button"
                    onClick={applyDelete}
                >
                    Delete
                </odx-button>
            ]}
            isOpen={true}
            variant={"default"}
            zIndex={1000}
            id={baseId}
        >
            <div id={`${baseId}-message`}>Are you sure you want to delete the key {apiKey.displayName}?</div>
        </OdxModal>
    );
};

export default deleteApikey;
